// Utility to detect if running in Flutter WebView and enhance sharing functionality

export const isFlutterWebView = (): boolean => {
  // Check for Flutter WebView specific indicators
  return (
    typeof window !== 'undefined' &&
    (window as any).flutter_inappwebview !== undefined ||
    (window as any).isFlutterWebView === true ||
    navigator.userAgent.includes('Flutter') ||
    navigator.userAgent.includes('InAppWebView')
  );
};
 
export const enhancedShare = async (data: {
  title?: string;
  text?: string;
  url?: string;
  files?: File[];
}): Promise<void> => {
  try {
    // If we're in a Flutter WebView, the bridge should handle this
    if (isFlutterWebView()) {
      console.log('Using Flutter WebView share bridge');
      
      if (data.files && data.files.length > 0) {
        // Handle file sharing through Flutter bridge
        const file = data.files[0];
        const reader = new FileReader();
        
        return new Promise((resolve, reject) => {
          reader.onload = async function() {
            try {
              const result = await (window as any).flutter_inappwebview.callHandler('shareFile', JSON.stringify({
                base64Data: reader.result,
                fileName: file.name,
                mimeType: file.type,
                title: data.title || 'Check out my anonymous Q&A!',
                text: data.text || ''
              }));
              
              if (result.success) {
                resolve();
              } else {
                reject(new Error(result.error || 'Share failed'));
              }
            } catch (error) {
              reject(error);
            }
          };
          reader.readAsDataURL(file);
        });
      } else {
        // Handle text/URL sharing through Flutter bridge
        const result = await (window as any).flutter_inappwebview.callHandler('shareContent', JSON.stringify({
          title: data.title || 'Check out my anonymous Q&A!',
          text: data.text || '',
          url: data.url || ''
        }));
        
        if (!result.success) {
          throw new Error(result.error || 'Share failed');
        }
      }
    } else {
      // Use native Web Share API
      if (navigator.share) {
        await navigator.share(data);
      } else {
        // Fallback for browsers without Web Share API
        throw new Error('Web Share API not supported');
      }
    }
  } catch (error) {
    console.error('Share error:', error);
    throw error;
  }
};

export const canShare = (data?: { files?: File[] }): boolean => {
  if (isFlutterWebView()) {
    return true; // Flutter bridge should handle sharing
  }
  
  if (navigator.share) {
    if (data?.files) {
      return navigator.canShare({ files: data.files });
    }
    return true;
  }
  
  return false;
}; 